// services/apiAuth.ts — header auth untuk panggilan ke backend S2.
// Selalu kirim x-api-key (jalur service). Bila ada sesi Supabase login, tambahkan
// `Authorization: Bearer <jwt>` agar backend (middleware attachUser) bisa menegakkan
// scope per-brand/per-CS. Fail-open: tanpa sesi (checkout publik, beacon) → hanya key,
// perilaku lama tidak berubah.
import { supabase } from '../supabase/client';

export async function backendHeaders(
    extra: Record<string, string> = {},
    apiKey = '',
): Promise<Record<string, string>> {
    const headers: Record<string, string> = { ...extra };
    if (apiKey) headers['x-api-key'] = apiKey;
    try {
        const { data } = await supabase.auth.getSession();
        const token = data?.session?.access_token;
        if (token) headers['Authorization'] = `Bearer ${token}`;
    } catch {
        // Abaikan — jalur service (x-api-key) tetap jalan.
    }
    return headers;
}
